export default "__VITE_ASSET__CI6q$Fn9__"